<template>
  <div class="flex-grow-1">
    <div class="mt-4" v-if="isLoading">
      <Spinner />
    </div>
    <a-row :gutter="20" v-if="!isLoading && !showEngine">
      <a-col :span="24">
        <div class="sub-descriptions">
          <h1>Try the new Deep Learning/NLP Engine!</h1>
          <p>We are pleased to launch the first version of our Deep Learning/NLP engine! Our engineering team has used Deep Learning Natural Language Processing (NLP) techniques to extract out keywords and entities found in defaced webpages over the past 10 years.  </p>
          <p>By enabling this engine, you are adding a new level of intelligence to your monitoring and will be alerted if any of these keywords appear in your webpage content.</p>
          <p>
            <a-button size="default" class="success-btn" @click="startTrial" v-if="canStartFreeTrial">
              Start your non-obligatory 60 days free trial now!
            </a-button>
            <a-button size="default" v-else>
              Contact us to subscribe to this engine
            </a-button>
          </p>
          <wordcloud
                  :data="wordCloudsKeywords['preview']"
                  font="Roboto"
                  :rotate="{from: 0, to: 0, numOfOrientation: 1 }"
                  nameKey="keyword"
                  valueKey="mentions"
          >
          </wordcloud>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="20" v-if="!isLoading && showEngine">
      <a-col :span="24">
        <div class="sub-descriptions">
          <div class="description-highlight ant-alert-warning">
            <p v-if="engineTrialEndDate">Trial period till <b>{{ engineTrialEndDate | dateString }}</b></p>
            <p>We are excited to have you try out this new engine!  Enable the checkboxes to monitor the relevant keywords and entities! </p>
            <p>We will love to hear your thoughts.  Please email custsupport@cloudsine.tech  for any questions or suggestions about this new feature.</p>
          </div>
          <!-- <wordcloud
                  :data="wordCloudsKeywords['overall']"
                  font="Roboto"
                  :rotate="{from: 0, to: 0, numOfOrientation: 1 }"
                  nameKey="keyword"
                  valueKey="mentions"
          >
          </wordcloud> -->
          <!--
          Note: do not bind more than one word cloud to the same data, otherwise it causes some Vue watch loops that causes the page/browser to hang
          That's why we have a different data source for the overall word cloud, even if it shows the same words
          -->
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="20" v-if="!isLoading && showEngine">
      <a-col :span="24" class="keywords-collapse">
        <a-collapse expand-icon-position="left" v-model="expandedKeywordsFirstLevel">
          <a-collapse-panel key="dataset-2020" header="Enable dataset 2020">
            <div slot="extra">
              <a-checkbox :checked="selectedKeywordsFirstLevelStatus['2020'].checked" :indeterminate="selectedKeywordsFirstLevelStatus['2020'].indeterminate" @change="onFirstLevelCheckboxChange('2020')" @click.stop @change.stop></a-checkbox>
            </div>
            <a-collapse expand-icon-position="left" v-model="expandedKeywordsSecondLevel['2020']">
              <a-collapse-panel key="2020-attacker" header="Attackers" :forceRender="true">
                <p>Sample keywords in this dataset:</p>
                <wordcloud
                        :data="wordCloudsKeywords['2020']"
                        font="Roboto"
                        :rotate="{from: 0, to: 0, numOfOrientation: 1 }"
                        nameKey="keyword"
                        valueKey="mentions"
                >
                </wordcloud>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2020']['attacker']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2020-organization" header="Organisations">
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2020']['organization']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2020']['organization']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2020-person" header="People">
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2020']['person']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2020']['person']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2020-title" header="Title">
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2020']['title']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2020']['title']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2020-other" header="Other">
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2020']['other']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2020']['other']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </a-collapse-panel>
          <a-collapse-panel key="dataset-2009-2019" header="Enable dataset 2009-2019" :forceRender="true">
            <div slot="extra">
              <a-checkbox :checked="selectedKeywordsFirstLevelStatus['2010-2019'].checked" :indeterminate="selectedKeywordsFirstLevelStatus['2010-2019'].indeterminate" @change="onFirstLevelCheckboxChange('2010-2019')" @click.stop @change.stop></a-checkbox>
            </div>
            <a-collapse expand-icon-position="left" v-model="expandedKeywordsSecondLevel['2010-2019']">
              <a-collapse-panel key="2010-2019-attacker" header="Attackers" :forceRender="true">
                <p>Sample keywords in this dataset:</p>
                <wordcloud
                        :data="wordCloudsKeywords['2010-2019']"
                        font="Roboto"
                        :rotate="{from: 0, to: 0, numOfOrientation: 1 }"
                        nameKey="keyword"
                        valueKey="mentions"
                >
                </wordcloud>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2010-2019']['attacker']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2010-2019-organization" header="Organisations">
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2010-2019']['organization']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2010-2019']['organization']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2010-2019-person" header="People">
                <!--<ul>
                  <li v-for="(occurrence, keyword) in keywords['2010-2019']['person']" v-bind:key="keyword">
                    <div style="color: #41b7c4; display: inline-block;">{{keyword}}</div> <div style="color: #a2a2a2; font-size: 80%; display: inline-block;">{{occurrence}} mentions</div>
                  </li>
                </ul>-->
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2010-2019']['person']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2010-2019']['person']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2010-2019-title" header="Title">
                <!--<ul>
                  <li v-for="(occurrence, keyword) in keywords['2010-2019']['title']" v-bind:key="keyword">
                    <div style="color: #41b7c4; display: inline-block;">{{keyword}}</div> <div style="color: #a2a2a2; font-size: 80%; display: inline-block;">{{occurrence}} mentions</div>
                  </li>
                </ul>-->
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2010-2019']['title']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2010-2019']['title']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2010-2019-other" header="Other">
                <!--<ul>
                  <li v-for="(occurrence, keyword) in keywords['2010-2019']['other']" v-bind:key="keyword">
                    <div style="color: #41b7c4; display: inline-block;">{{keyword}}</div> <div style="color: #a2a2a2; font-size: 80%; display: inline-block;">{{occurrence}} mentions</div>
                  </li>
                </ul>-->
                <p>Sample keywords in this dataset:</p>
                <ol>
                  <li v-for="(occurrence, keyword) in keywords['2010-2019']['other']" v-bind:key="keyword">
                    <code style="display: inline-block; line-height: 30px;">{{keyword}}</code> <div style="display: inline-block;"><a-tag color="orange">{{occurrence}} mentions</a-tag></div>
                  </li>
                </ol>
                <div slot="extra">
                  <a-checkbox v-model="selectedKeywords['2010-2019']['other']" @click.stop @change.stop></a-checkbox>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="24">
        <!-- Add a little bit of space at the end of the page -->
        <br/><br/>
      </a-col>
    </a-row>
  </div>
</template>

<style lang="scss">
  .keywords-collapse .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
    float: left !important;
    margin-right: 8px;
  }
  .keywords-collapse > .ant-collapse {
    background-color: #aedef2;
  }
  div.tooltip {
    width: auto !important;
    height: auto !important;
    font-size: 14px !important;
  }
</style>

<style lang="scss" scoped>
  .a-body {
    .sub-descriptions {
      background: #f7f7f7;
      overflow: hidden;
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 20px;
    }
  }
  ol {
    column-width: 30em;
  }
  .description-highlight {
    padding: 15px;
  }
</style>


<script>
  import ApiService from '@shared/services/api.service';
  import wordcloud from 'vue-wordcloud'
  import moment from 'moment';
  import { keywords } from '../consts/KeywordSetsPreview.const';

  const wordCloudsKeywords = {
    'overall': [],
    'preview': [],
    '2020': [],
    '2010-2019': []
  };

  let selectedKeywords = {
    '2020': {
      'attacker': false,
      'organization': false,
      'person': false,
      //'event': false,
      'title': false,
      'other': false,
    },
    '2010-2019': {
      'attacker': false,
      'organization': false,
      'person': false,
      //'event': false,
      'title': false,
      'other': false,
    }
  };

  let expandedKeywordsFirstLevel = ['dataset-2020'];

  let expandedKeywordsSecondLevel = {
    '2020': ['2020-attacker'],
    '2010-2019': [],
  };

  export default {
    name: 'NLPKeywords',
    components: {
      wordcloud: wordcloud
    },
    props: ['selectedKeywordSets'],
    data() {
      return {
        keywords: keywords,
        wordCloudsKeywords: wordCloudsKeywords,
        selectedKeywords: selectedKeywords,
        progress: null,
        selectedKeywordSetsUpdated: [],
        isLoading: true,
        isEngineSubscribed: false,
        isEngineTrial: false,
        engineTrialEndDate: null,
        expandedKeywordsFirstLevel: expandedKeywordsFirstLevel,
        expandedKeywordsSecondLevel: expandedKeywordsSecondLevel
      };
    },
    beforeMount() {

      // Format the hacker terms in the appropriate format for the word cloud
      let wordCloudWords = this.keywords['2010-2019']['attacker'];

      this.wordCloudsKeywords['2010-2019'] = [];
      this.wordCloudsKeywords['2020'] = [];
      this.wordCloudsKeywords['overall'] = [];
      this.wordCloudsKeywords['preview'] = [];

      for (let word in wordCloudWords) {
        let count = wordCloudWords[word];
        this.wordCloudsKeywords['2010-2019'].push({"keyword": word, "mentions": count});
        this.wordCloudsKeywords['overall'].push({"keyword": word, "mentions": count});
        this.wordCloudsKeywords['preview'].push({"keyword": word, "mentions": count});
      }

      let wordCloudWords2020 = this.keywords['2020']['attacker'];

      for (let word in wordCloudWords2020) {
        let count = wordCloudWords2020[word];
        this.wordCloudsKeywords['2020'].push({"keyword": word, "mentions": count});
        this.wordCloudsKeywords['overall'].push({"keyword": word, "mentions": count});
        this.wordCloudsKeywords['preview'].push({"keyword": word, "mentions": count});
      }
    },
    mounted() {
      // We have this in case the watcher is only set up AFTER the keywords have been set
      if (this.selectedKeywordSets) {
        this.convertKeywordSetsArrayToKeywordsObject(this.selectedKeywordSets);
      }

      this.getDatas();
    },
    computed: {
      selectedKeywordsFirstLevelStatus() {
        let selectedKeywordsFirstLevel = {};

        for (let firstLevelLabel in selectedKeywords) {
          selectedKeywordsFirstLevel[firstLevelLabel] = {
            checked: true,
            indeterminate: false,
          }

          let isAllChecked = true;
          let isAnyChecked = false;
          for (let secondLevelLabel in selectedKeywords[firstLevelLabel]) {
            if (selectedKeywords[firstLevelLabel][secondLevelLabel] == false) {
              isAllChecked = false;
            }
            if (selectedKeywords[firstLevelLabel][secondLevelLabel] == true) {
              isAnyChecked = true;
            }
          }

          if (isAllChecked) {
            selectedKeywordsFirstLevel[firstLevelLabel].checked = true;
            selectedKeywordsFirstLevel[firstLevelLabel].indeterminate = false;
          }

          if (isAnyChecked && !isAllChecked) {
            selectedKeywordsFirstLevel[firstLevelLabel].checked = false;
            selectedKeywordsFirstLevel[firstLevelLabel].indeterminate = true;
          }

          if (!isAnyChecked) {
            selectedKeywordsFirstLevel[firstLevelLabel].checked = false;
            selectedKeywordsFirstLevel[firstLevelLabel].indeterminate = false;
          }
        }

        return selectedKeywordsFirstLevel;
      },
      featureAccess() {
        return this.$store.state.user.data.feature_access;
      },
      canStartFreeTrial() {
        // We can only start the trial when there is no existing trial, and the user has not subscribed

        // For the whole trial thing, there are 4 cases:
        // 1. User just subscribe immediately without going to trial (this.isEngineSubscribed = true)
        // 2. User trialing the engine, and trial is still valid (this.isEngineTrial = true, this.engineTrialEndDate > now)
        // 3. User has trialed and trial is expired  (this.isEngineTrial = true, this.engineTrialEndDate <= now)
        // 4, User has trialed and subscribed (this.isEngineTrial = true, this.isEngineSubscribed = true)
        if (this.isEngineTrial || this.isEngineSubscribed) {
          return false;
        }

        return true;
      },
      showEngine() {
        if (this.isEngineSubscribed) {
          return true;
        }

        if (this.isEngineTrial && this.engineTrialEndDate) {
          const now = moment();
          if (moment(this.engineTrialEndDate).isAfter(now)) {
            return true;
          }
        }

        return false;
      }
    },
    watch: {
      selectedKeywordSets: {
        deep: true,
        handler: function (val) {
          if (!val) {
            return val;
          }
          this.convertKeywordSetsArrayToKeywordsObject(val);
        }
      },
      selectedKeywords: {
        deep: true,
        handler: function (val) {
          console.log("Val change", val);
          this.selectedKeywordSetsUpdated.splice(0); // empty the array in a reactive-compatible manner
          for (let firstLevelLabel in val) {
            for (let secondLevelLabel in val[firstLevelLabel]) {
              if (selectedKeywords[firstLevelLabel][secondLevelLabel] === true) {
                this.selectedKeywordSetsUpdated.push(firstLevelLabel + ":" + secondLevelLabel)
              }
            }
          }
          // Somehow, we cannot "update back" the selectedKeywordSets else we end up with an update loop
        }
      }
    },
    methods: {
      onFirstLevelCheckboxChange(firstLevelLabel) {
        for (let secondLevelLabel in this.selectedKeywords[firstLevelLabel]) {
          this.selectedKeywords[firstLevelLabel][secondLevelLabel] = event.target.checked;
        }
      },
      convertKeywordSetsArrayToKeywordsObject(keywordSetsArray) {
        // Reset everything to false first
        for (let firstLevelLabel in this.selectedKeywords) {
          for (let secondLevelLabel in this.selectedKeywords[firstLevelLabel]) {
            this.selectedKeywords[firstLevelLabel][secondLevelLabel] = false;
          }
        }

        // Then if the setting exists, we set it to true
        for (let i = 0; i < keywordSetsArray.length; i++) {
          let keywordSet = keywordSetsArray[i];
          let [firstLevelLabel, secondLevelLabel] = keywordSet.split(":");
          console.log("in convertKeywordSetsArrayToKeywordsObject", firstLevelLabel, secondLevelLabel)
          if (firstLevelLabel in this.selectedKeywords && secondLevelLabel in this.selectedKeywords[firstLevelLabel]) {
            console.log("yes in convertKeywordSetsArrayToKeywordsObject", firstLevelLabel, secondLevelLabel)
            this.selectedKeywords[firstLevelLabel][secondLevelLabel] = true;
          }
        }
      },
      async getDatas() {
        try {
          const [trialStatus] = await Promise.all([ApiService.get('trial_features/keyword_sets')]);

          if (trialStatus) {
            this.isEngineTrial = true;
            this.engineTrialEndDate = trialStatus.ends;
          }

          this.isEngineSubscribed = this.featureAccess['keyword-sets-engine'];

        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        } finally {
          if (this.isLoading) {
            this.isLoading = false;
          }
        }
      },
      async startTrial() {
        this.isLoading = true;
        await ApiService.post('trial_features/keyword_sets/start_trial');
        await this.getDatas();
        this.isLoading = false;
      }
    },
  };
</script>
